import banner_section from  './banner_section.png'
import header1 from  './header1.png'
import header2 from  './header2.png'
import header3 from  './header3.png'
import logo from  './logo.png'
import roman from  './roman.png'
import walker from  './walker.png'
import hardy from  './hardy.png'
import coppice from  './coppice.png'
import community from  './community.png'
import holyhead from  './holyhead.png'
import bridle from './bridle.png'
import vincent from  './vincent.webp'
import hugh from  './hugh.webp'
import roger from  './roger.webp'
import nick from  './nick.webp'
import jenna from  './jenna.webp'
import laurenm from  './laurenm.webp'
import molly from  './molly.webp'
import hanna from  './hanna.webp'
import annas from  './annas.webp'
import annaj from  './annaj.webp'
import natalie from  './natalie.webp'
import elise from  './elise.webp'
import dominika from  './dominika.webp'
import craig from  './craig.webp'
import chloe from  './chloe.webp'
import gemma from  './gemma.webp'
import ico from  './ico.png'
import ikon from  './ikon.png'
import rrn from  './rrn.svg'
import cqc from  './cqc.png'
import dcc from  './dcc.webp'
import bild from  './bild.svg'
import joe from  './joe.webp'
import janet from  './janet.webp'
import cat from './cat.webp'
import harriet from  './harriet.webp'
import logoblue from  './logoblue.png'
import rachael from  './rachael.webp'
import support1 from  './support1.webp'
import support2 from  './support2.webp'
import support3 from  './support3.webp'
import support4 from  './support4.webp'
import support5 from  './support5.webp'
import support6 from  './support6.webp'
import support7 from  './support7.webp'
import support8 from  './support8.webp'
import support9 from  './support9.webp'
import support10 from  './support10.webp'
import support11 from  './support11.webp'
import support12 from  './support12.webp'
import support13 from  './support13.webp'
import support14 from  './support14.webp'
import support15 from  './support15.webp'
import support16 from  './support16.webp'
import support17 from  './support17.webp'
import support18 from  './support18.webp'
import support19 from  './support19.webp'
import support20 from  './support20.webp'
import support21 from  './support21.webp'
import support22 from  './support22.webp'
import support23 from  './support23.webp'
import support24 from  './support24.webp'
import support25 from  './support25.webp'
import support26 from  './support26.webp'
import support27 from  './support27.webp'
import telford from './telford.png'
import shropshire from './shropshire.png'
import coventry from './coventry.png'
import stoke from './stoke.png'
import icb from './icb.png'
import inclusion from './inclusion.png'
import halo from './halo.png'
import ironoak from './ironoak.jpg'
import partners from './partners.png'
import skills from './skills.svg'


const Images = {
  banner_section,
  header1,
  header2,
  header3,
  logo: logo,
  // house: house,
  roman,
  walker,
  hardy,
  bridle,
  coppice,
  community,
  holyhead,
  vincent,
  hugh,
  roger,
  jenna,
  laurenm,
  molly,
  hanna,
  annas,
  annaj,
  natalie,
  elise,
  dominika,
  craig,
  chloe,
  gemma,
  ico,
  ikon,
  rrn,
  cqc,
  dcc,
  bild,
  joe,
  janet,
  harriet,
  logoblue,
  rachael,
  cat,
  nick,
  // janet,
  support1,
  support2,
  support3,
  support4,
  support5,
  support6,
  support7,
  support8,
  support9,
  support10,
  support11,
  support12,
  support13,
  support14,
  support15,
  support16,
  support17,
  support18,
  support19,
  support20,
  support21,
  support22,
  support23,
  support24,
  support25,
  support26,
  support27,
  telford,
  shropshire,
  coventry,
  stoke,
  icb,
  inclusion,
  halo,
  ironoak,
  partners,
  skills,
}

export default Images